/*
  The store's minimum order in the cart (2026-10-18, the tracker: "Stick Flags minimum order
  quantity not applied on new theme"). Each line's quantity input carries `data-atlas-min`
  (snippets/atlas-min-qty: the product's ols.min_purchase_qty, or the variant's rule). A line
  below its minimum, other than one being removed (0), is raised to it, as on the live
  theme; the cart then redraws itself.
*/
(() => {
  if (window.atlasMinQty) return;
  window.atlasMinQty = true;
  let busy = false;
  const enforce = async () => {
    if (busy) return;
    const low = [...document.querySelectorAll('cart-items input[data-atlas-min], cart-drawer-items input[data-atlas-min]')]
      .filter((input) => {
        const min = Number(input.dataset.atlasMin) || 1;
        const qty = Number(input.value);
        return min > 1 && qty > 0 && qty < min && input.dataset.quantityLineKey;
      });
    if (!low.length) return;
    busy = true;
    try {
      const seen = new Set();
      for (const input of low) {
        const key = input.dataset.quantityLineKey;
        if (seen.has(key)) continue;
        seen.add(key);
        await fetch(`${(window.routes && window.routes.cart_change_url) || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Number(input.dataset.atlasMin) }),
        });
      }
      document.querySelectorAll('cart-items, cart-drawer-items').forEach((el) => {
        if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
      });
    } finally {
      busy = false;
    }
  };
  const start = () => {
    enforce();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(enforce, 300));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
